// DS: PO60
import React, { useState } from 'react';
import { compose } from 'redux';
import Premium from '@wix/da-ds/pkg/Icons/24x24/Premium';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import { MAX_TITLE_LENGTH, getFolderNameValidationErrorMessage, } from '../../../utils/isValidFolderName';
import { useTranslation } from 'react-i18next';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import withGallections from '../../_hocs/withGallections';
import withCurrentGallectionSubfolders from '../../_hocs/withCurrentGallectionSubfolders';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { createGallection } from '../../actions';
import PremiumForm, { FolderType } from './PremiumForm';
import { getIsOnlyPaidFoldersSelector } from '../../selectors';
import { MediaSourceType } from '../../types';
import { getCoreLevel, getCurrentUserHasCore, } from '../../../publicSession/selectors';
import newGallectionPopupStyles from './NewGallectionPopup.scss';
var INITIAL_POINTS_PRICE = 0;
var INITIAL_INPUT_VALUE = '';
var enhance = compose(withCurrentMediaSource, withCurrentGallection, withGallections, withCurrentGallectionSubfolders, connectMediaStore(function (state) { return ({
    onlyNewPaidFolders: getIsOnlyPaidFoldersSelector(state),
    coreLevel: getCoreLevel(state),
    hasCoreMembership: getCurrentUserHasCore(state),
}); }, {
    createGallection: createGallection,
}));
export var NewGallectionPopup = function (_a) {
    var currentMediaSource = _a.currentMediaSource, currentFolderId = _a.currentFolderId, subfolders = _a.subfolders, topLevelGallections = _a.gallections, _b = _a.onlyNewPaidFolders, onlyNewPaidFolders = _b === void 0 ? false : _b, coreLevel = _a.coreLevel, hasCoreMembership = _a.hasCoreMembership, onCancel = _a.onCancel, onDone = _a.onDone, createGallectionAction = _a.createGallection;
    var t = useTranslation().t;
    var _c = useState(INITIAL_INPUT_VALUE), inputValue = _c[0], setInputValue = _c[1];
    var _d = useState(onlyNewPaidFolders ? FolderType.PAID : FolderType.REGULAR), folderType = _d[0], setFolderType = _d[1];
    var _e = useState(), premiumFormHasErrors = _e[0], setPremiumFormHasErrors = _e[1];
    var _f = useState(INITIAL_POINTS_PRICE), priceInPoints = _f[0], setPriceInPoints = _f[1];
    var withPremiumForm = currentMediaSource === MediaSourceType.GALLERY &&
        !currentFolderId; /* PF can not be a sub-folder */
    var getValidationErrorIfAny = function (name) {
        var existingNames = (currentFolderId
            ? subfolders
            : topLevelGallections).map(function (gallection) { return gallection.name; });
        return getFolderNameValidationErrorMessage(name, t, existingNames, currentMediaSource === MediaSourceType.GALLERY);
    };
    var errorHint = inputValue !== INITIAL_INPUT_VALUE
        ? getValidationErrorIfAny(inputValue)
        : undefined;
    var onSubmit = function () {
        createGallectionAction({
            name: inputValue,
            priceInPoints: priceInPoints,
            folderType: folderType,
        });
        onDone && onDone();
    };
    var onTitleKeyUp = function (ev) {
        if (!errorHint && ev.key === 'Enter') {
            onSubmit();
        }
    };
    var newFolderKeyPart = currentFolderId ? 'newSubGallery' : 'new';
    return (React.createElement(DSModal, { isOpen: true, onRequestClose: onCancel, className: newGallectionPopupStyles['root'], contentClassName: newGallectionPopupStyles['content'], heading: onlyNewPaidFolders
            ? t("mediapopup.gallections.premiumFolder.prompt.".concat(newFolderKeyPart, ".title"))
            : t("mediapopup.gallections.".concat(currentMediaSource, ".prompt.").concat(newFolderKeyPart, ".title")), headerRight: withPremiumForm &&
            onlyNewPaidFolders && (React.createElement("div", { className: newGallectionPopupStyles['sub-title'] },
            React.createElement(Premium, { size: IconSize.TINY, className: newGallectionPopupStyles['sub-title-icon'] }),
            t('mediapopup.newFolderPopup.subtitle.paidFolders'))), footerRight: [
            React.createElement(TextButton, { key: "cancel", onClick: onCancel, size: "large", variant: "main" }, t('popup.cancel')),
            React.createElement(BrandedButton, { key: "submit", size: "large", variant: "brand-green", disabled: !!errorHint ||
                    premiumFormHasErrors ||
                    inputValue.length < 1 ||
                    (folderType === 'paid' && priceInPoints === INITIAL_POINTS_PRICE), onClick: onSubmit }, t('mediapopup.create')),
        ] },
        React.createElement("div", null,
            React.createElement(TextInput, { id: "collection-title-input", value: inputValue, label: t("mediapopup.gallections.".concat(currentMediaSource, ".prompt.").concat(newFolderKeyPart, ".label")), validationResult: errorHint ? 'error' : undefined, details: errorHint, maxLength: MAX_TITLE_LENGTH, onChange: function (ev) { return setInputValue(ev.target.value); }, onKeyUp: onTitleKeyUp, autoFocus: true })),
        withPremiumForm && (React.createElement(PremiumForm, { coreLevel: coreLevel, hasCoreMembership: hasCoreMembership, folderType: folderType, priceInPoints: priceInPoints, onSetError: setPremiumFormHasErrors, onFolderTypeChange: setFolderType, onSetPriceInPoints: setPriceInPoints, onlyNewPaidFolders: onlyNewPaidFolders }))));
};
NewGallectionPopup.displayName = 'NewGallectionPopup';
export default enhance(NewGallectionPopup);
//# sourceMappingURL=NewGallectionPopup.connected.js.map